import React from 'react'
import { Navigate } from 'react-router-dom'
import { LANDING_PATH } from '../../marketing/marketingNav'

export default function ProductPage() {
  return <Navigate to={LANDING_PATH} replace />
}
